<template>
  <SplitViewTemplate 
    :screenConfig="data" 
    :backButtonRoute="'/settings/intake'" 
    :dataModel="formModel"
    :formConfig="setFormConfig" 
    :setLoading="setLoading" 
    :validationSummary="validationSummary" 
    :ref="'intake-size'"
    :defaultUserSettings="false" />
</template>
<script>
import { FeatureStorage } from "@/_services/storage";
import SplitViewTemplate from "../../../templates/split-view";
import RouteMixin from "@/_mixins/route.mixin";
export default {
  mixins: [RouteMixin],
  components: {
    SplitViewTemplate,
  },
  data() {
    return {
      setLoading: false,
      validationSummary: [],
      formModel: {
        Code: null,
        Name: null,
        Inactive: false,
        ChangedBy: "",
        CreatedBy: "",
        DateChanged: "",
        DateCreated: "",
      },
      data: {
        title: "Intake Size",
        pageRoute: "/intake-size",
        saveEndPoint: "AlmondcoIntakeSize",
        updateEndPoint: "AlmondcoIntakeSize",
        updateKeyField: "Code",
        updateKeyFieldType: "String",
        recordEndPoint: "AlmondcoIntakeSize",
        exportFileName: "Intake Size",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "AlmondcoIntakeSize",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
              sort: [{ selector: "Name", desc: false }],
            },
            rowSelect: {
              view: this,
              page: "intake-size",
              mode: "review",
              idProperty: "Code",
              idMode: "String",
              rowSelectCallBack: () => {
                this.beforeInit();
              },
            },
          },

          toolbar: {
            search: true,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/intake-size/create",
                clickAction: () => {
                  this.goToCreateIntakeSize();
                },
                buttonLocation: "left",
                // disabled: false,
                visible: FeatureStorage.checkPermission(
                   "AlmondcoIntakeSettings",
                   "create"
                ),
              },
            ],
          },
          columns: [
            {
              screenField: "Code",
              label: "Code",
              dataField: "Name",
              sortOrder: "asc",
              sortIndex: 0,
              allowHiding: false,
              cellTemplate: "Record",
              cellTemplateRecord: {
                primary: [
                  {
                    dataField: "Name",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              exportFields: [
                {
                  dataField: "Code",
                  label: "Code",
                },
                {
                  dataField: "Name",
                  label: "Description",
                },
              ],
            },
            {
              screenField: "Status",
              width: "auto",
              filterIndex: 0,
            },
          ],
          valueChangedEventListners: [],
        },
      },
      updatedDefaultRecordId: undefined,
      recordEditable: true,
    };
  },
  computed: {
    setFormConfig() {
      const form = {
        headerToolbar: {
          closeSplit: true,
          save: this.setSaveOption,
          audit: true,
          auditItems: [
            {
              itemType: "group",
              caption: "",
              items: [
                {
                  dataField: "FormattedDateCreated",
                  label: { text: "Created By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
                {
                  dataField: "FormattedDateChanged",
                  label: { text: "Changed By", location: "left" },
                  editorType: "dxTextBox",
                  editorOptions: {
                    disabled: true,
                  },
                },
              ],
            },
          ],
          toolbarFormItems: [
            {
              screenField: "Inactive",
              editorType: "dxSwitch",
              editorOptions: {
                readOnly: false,
              },
              cssClass: "toolbar-customer-label",
            },
          ],
          toolbarFormLocation: "after",
          editCallBack: () => {
            this.beforeInit();
          },
        },
        formItems: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "Code",
                editorType: "dxTextBox",
                editorOptions: {
                  min: 0,
                  tabIndex: 1,
                  maxLength: 25,
                },
                required: true,
                isPrimaryKeyField: true,
                label: { text: "Code" },
                visible: true,
                allowUpdate: this.baseView.mode == "create" ? true : false,
              },
              {
                dataField: "Name",
                editorType: "dxTextBox",
                editorOptions: {
                  min: 0,
                  tabIndex: 2,
                  maxLength: 25,
                },
                required: true,
                label: { text: "Description" },
                visible: true,
                allowUpdate: this.recordEditable,
              },
            ],
          },
        ],
        overWritePayload: this.overWritePayload,
      };

      return form;
    },
    setSaveOption() {
      return FeatureStorage.checkPermission(
        this.$route.meta.applicationFeatureCode,
        "create"
      );
    },
  },
  methods: {
    goToCreateIntakeSize() {
      this.$router
        .push({
          path: `/intake-size/create`,
        })
        .then(() => {
          this.recordEditable = true;
        });
    },
    beforeInit() {
      this.recordEditable = true;
    },
    overWritePayload(payload) {
      return payload;
    },
  },
  created() {
    this.beforeInit();
  },
};
</script>
